export const addAnalytics = (id) => {
  if (id) {
    let analyticsHtml = "\n" + "window.dataLayer = window.dataLayer || [];" + "\n";
    analyticsHtml += "function gtag(){dataLayer.push(arguments);}" + "\n";
    analyticsHtml += "gtag('js', new Date());" + "\n";
    analyticsHtml += "gtag('config', '" + id + "');" + "\n";

    let scripts = [
      {
        src: "https://www.googletagmanager.com/gtag/js?id=" + id,
        async: true,
      },
      {
        innerHTML: analyticsHtml,
      },
    ];

    useHead({
      script: scripts,
    });
  }
};

export const triggerPurchaseEvent = (purchase, store) => {
  const affiliation = store.siteSettings.site_title + " - " + store.siteSettings.site.country_name;
  const currency = purchase.currency || store.siteSettings.currency.code;

  const items = (purchase.items || []).map((item, index) => ({
    item_id: item.item_id,
    item_name: item.item_name,
    affiliation,
    price: Number(item.price),
    quantity: item.quantity ?? 1,
    discount: item.discount ?? 0,
    index: item.index ?? index,
    coupon: item.coupon ?? "",
    item_brand: item.item_brand ?? "",
    item_category: item.item_category ?? "",
    item_variant: item.item_variant ?? "",
  }));

  const eventData = {
    transaction_id: purchase.transaction_id,
    value: Number(purchase.value),
    currency,
    tax: purchase.tax ?? 0,
    shipping: purchase.shipping ?? 0,
    coupon: purchase.coupon ?? "",
    items,
  };

  const ecommerceJson = JSON.stringify(eventData);
  const analyticsHtml =
    "\nwindow.dataLayer = window.dataLayer || [];" +
    "\nwindow.dataLayer.push({ ecommerce: null });" +
    "\nwindow.dataLayer.push({ event: 'purchase', ecommerce: " +
    ecommerceJson +
    " });" +
    "\ngtag('event', 'purchase', " +
    ecommerceJson +
    ");\n";

  useHead({
    script: [{ innerHTML: analyticsHtml }],
  });
};

export const addGTMAnalytics = (id) => {
  if (id) {
    let analyticsHtml = "\n" + "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" + "\n";
    analyticsHtml += "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," + "\n";
    analyticsHtml += "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" + "\n";
    analyticsHtml += "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" + "\n";
    analyticsHtml += "})(window,document,'script','dataLayer','" + id + "');" + "\n";

    let bodyHtml =
      '<iframe src="https://www.googletagmanager.com/ns.html?id=' +
      id +
      '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';

    let scripts = [
      {
        innerHTML: analyticsHtml,
      },
    ];

    let noscript = [
      {
        innerHTML: bodyHtml,
        tagPosition: "bodyOpen",
      },
    ];

    useHead({
      script: scripts,
      //noscript: noscript,
    });
  }
};
